export interface ThreeDs2Requisites {
    confirmationType: string;
    mdOrder: string;
    threeDsMethodUrl: string;
    threeDsMethodData: string;
}

export interface ThreeDs2ProceedResponse {
    acsUrl: string;
    cReq: string;
}

export interface BrowserPayload {
    browserAcceptHeader: string;
    browserColorDepth: number;
    browserJavaEnabled: boolean;
    browserLanguage: string;
    browserScreenHeight: number;
    browserScreenWidth: number;
    browserTZ: number;
    browserUserAgent: string;
}

export function isThreeDs2Requisites(requisites: any): requisites is ThreeDs2Requisites {
    return !!requisites && requisites.confirmationType === 'FINISH_3DS2';
}

const ALLOWED_COLOR_DEPTHS = [1, 4, 8, 15, 16, 24, 32, 48];

function normalizeColorDepth(depth: number): number {
    const actual = depth || 24;
    let result = ALLOWED_COLOR_DEPTHS[0];
    for (const allowed of ALLOWED_COLOR_DEPTHS) {
        if (allowed <= actual) {
            result = allowed;
        }
    }
    return result;
}

export function collectBrowserPayload(): BrowserPayload {
    return {
        browserAcceptHeader: '*/*',
        browserColorDepth: normalizeColorDepth(screen.colorDepth),
        browserJavaEnabled: false,
        browserLanguage: navigator.language || 'ru',
        browserScreenHeight: screen.height,
        browserScreenWidth: screen.width,
        browserTZ: new Date().getTimezoneOffset(),
        browserUserAgent: navigator.userAgent,
    };
}

export function runThreeDsMethod(
    methodUrl: string,
    methodData: string,
    timeoutMs = 10000,
): Promise<void> {
    return new Promise((resolve) => {
        let done = false;

        const iframeName = `tds-method-${Date.now()}`;
        const iframe = document.createElement('iframe');
        iframe.name = iframeName;
        iframe.setAttribute('aria-hidden', 'true');
        iframe.tabIndex = -1;
        iframe.style.cssText = 'display:none;width:0;height:0;border:0;position:absolute;left:-9999px;top:-9999px;';

        const form = document.createElement('form');
        form.method = 'POST';
        form.action = methodUrl;
        form.target = iframeName;
        form.style.display = 'none';

        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'threeDSMethodData';
        input.value = methodData;
        form.appendChild(input);

        const finish = () => {
            if (done) {
                return;
            }
            done = true;
            clearTimeout(timer);
            iframe.removeEventListener('load', onLoad);
            iframe.remove();
            resolve();
        };

        const onLoad = () => {
            try {
                if (iframe.contentWindow && iframe.contentWindow.location.href === 'about:blank') {
                    return;
                }
            } catch (e) {
                finish();
                return;
            }
            finish();
        };

        const timer = setTimeout(finish, timeoutMs);

        iframe.addEventListener('load', onLoad);
        document.body.appendChild(iframe);
        document.body.appendChild(form);

        form.submit();
        form.remove();
    });
}

export function submitChallenge(acsUrl: string, cReq: string): void {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = acsUrl;
    form.style.display = 'none';

    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'creq';
    input.value = cReq;
    form.appendChild(input);

    document.body.appendChild(form);
    form.submit();
}
